export const BASE_URL = (function () {
    if (process.env.REACT_APP_BASE_URL) {
      return process.env.REACT_APP_BASE_URL;
    }
  
    if (process.env.NODE_ENV === 'development') {
        return "http://localhost:8080";
    }
  
    return ""; // for netlify
  
})();
  
export interface BaseAxiosResponse { }

interface Headers {
    [key: string] : string;
}

export function getHeaders() {
    let headers : Headers = {};
    headers['Content-Type'] = 'application/json';
    return headers;
}